import React /*, { useState, useEffect }*/ from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import logo1RIGO from "../imgs/logorigo (1).png";
/*import api from "../utils/api.utils";*/

import "./NavbarAdmin.css";

export const NavbarAdmin = ({ setLoggedIn }) => {
  const navigate = useNavigate();

  const userID = localStorage.getItem("userId");

  if (!userID) {
    navigate("/admin/login/");
  }

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("entidade");

    setLoggedIn(false);

    navigate("/admin/login");
  };

  const { pathname } = useLocation();
  const newLocation = pathname.split("/");
  const isActive = (path) => newLocation[2] === path;

  return (
    <>
      <Navbar className="nav-ouvidoria-admin">
        <div className="container">
          <Navbar.Brand
            as={Link}
            to={"/admin/home"}
            className=" d-flex align-items-center mx-3"
          >
            <img src={logo1RIGO} alt="Logotipo 1RIGO" className="logo-1rigo" />
            <b className="mx-2"> Ouvidoria 1RIGO</b>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-between"
          >
            <Nav className="mr-auto px-3">
              <Nav.Link
                className="link no-mobile"
                as={Link}
                to="/admin/home/"
                active={isActive("home")}
              >
                <i className="bi bi-house-door-fill"></i>
                HOME
              </Nav.Link>
              <Nav.Link
                className="link no-mobile"
                as={Link}
                to="/admin/mailbox/"
                active={isActive("mailbox")}
              >
                <i className="bi bi-envelope-open"></i>MAIL-BOX
              </Nav.Link>
              <Nav.Link
                className="link no-mobile"
                as={Link}
                to="/admin/manifestacoes/"
                active={isActive("manifestacoes")}
              >
                <i className="bi bi-list-task"></i>TIPOS
              </Nav.Link>
              <Nav.Link
                className="link no-mobile"
                as={Link}
                to="/admin/relatorios/"
                active={isActive("relatorios")}
              >
                <i className="bi bi-bar-chart-line-fill"></i>RELATÓRIOS
              </Nav.Link>
              <Nav.Link
                className="link no-mobile"
                as={Link}
                to="/admin/users/"
                active={isActive("users")}
              >
                <i className="bi bi-people-fill"></i>USUÁRIOS
              </Nav.Link>
              <Nav.Link
                className="link no-mobile"
                as={Link}
                to="/admin/login"
                onClick={logout}
              >
                <i className="bi bi-box-arrow-right"></i>SAIR
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </>
  );
};
